import  gql  from 'graphql-tag'

export const contingentQuotasTdcAgro = gql`query contingentQuotasTdcAgro{ 
    contingentQuotasTdcAgro{
            edges{
                node{
                    id,
                    data
                }
            }
        }
    }`;
